import { gql } from "@apollo/client";
import { BLOCK_FIELDS } from "./query.js";

export const CREATE_BLOCK = gql`
  mutation createBlock($input: CreateBlockInput!) {
    createBlock(input: $input) {
      block {
        ${BLOCK_FIELDS}
      }
    }
  }
`;

export const UPDATE_BLOCK = gql`
  mutation updateBlock($input: UpdateBlockInput!) {
    updateBlock(input: $input) {
      block {
        ${BLOCK_FIELDS}
      }
    }
  }
`;

export const DELETE_BLOCK = gql`
  mutation deleteBlock($id: ID!) {
    deleteBlock(id: $id) {
      id
    }
  }
`;
